import type { AnchorHTMLAttributes, ReactElement } from 'react'

import { ChevronRightIcon } from '@twistopayments/design-system/icons/inline'

import { Link } from '../../../atoms/link'
import { SelectableListItem } from '../selectable-list-item'

import * as styles from './selectable-list-item-link.styles'

type Props = {
  children: ReactElement | ReactElement[]
  to?: string
  arrangement?: 'row' | 'column'
  hideArrow?: boolean
  noMargin?: boolean
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'type'>

export const SelectableListItemLink = ({
  children,
  arrangement = 'column',
  noMargin = false,
  hideArrow = false,
  ...other
}: Props) => {
  const linkProps =
    other.to !== undefined
      ? { component: Link }
      : {
          component: 'a' as const,
          target: '_blank',
        }
  const onSubmit = other.onClick

  const paperStyles = [
    arrangement === 'row' && styles.rowListItem,
    noMargin && styles.noMargin,
  ]

  return (
    <SelectableListItem
      data-testid="selectable-list-item-link"
      type="link"
      {...linkProps}
      {...other}
      css={paperStyles}
      onSubmit={onSubmit}
    >
      <>
        {children}
        {!hideArrow && (
          <ChevronRightIcon color="inherit" css={styles.greyIcon} />
        )}
      </>
    </SelectableListItem>
  )
}
